// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/docs/v1/docs.proto (package mono.docs.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * DocumentType identifies the editor flavour. Matches file extension.
 *
 * @generated from enum mono.docs.v1.DocumentType
 */ export var DocumentType = /*#__PURE__*/ function(DocumentType) {
    /**
   * @generated from enum value: DOCUMENT_TYPE_UNSPECIFIED = 0;
   */ DocumentType[DocumentType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DOCUMENT_TYPE_DOCX = 1;
   */ DocumentType[DocumentType["DOCX"] = 1] = "DOCX";
    /**
   * @generated from enum value: DOCUMENT_TYPE_XLSX = 2;
   */ DocumentType[DocumentType["XLSX"] = 2] = "XLSX";
    /**
   * @generated from enum value: DOCUMENT_TYPE_PPTX = 3;
   */ DocumentType[DocumentType["PPTX"] = 3] = "PPTX";
    return DocumentType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DocumentType)
proto3.util.setEnumType(DocumentType, "mono.docs.v1.DocumentType", [
    {
        no: 0,
        name: "DOCUMENT_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DOCUMENT_TYPE_DOCX"
    },
    {
        no: 2,
        name: "DOCUMENT_TYPE_XLSX"
    },
    {
        no: 3,
        name: "DOCUMENT_TYPE_PPTX"
    }
]);
/**
 * @generated from message mono.docs.v1.PingRequest
 */ export class PingRequest extends Message {
    static fromBinary(bytes, options) {
        return new PingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingRequest, "runtime", proto3);
_define_property(PingRequest, "typeName", "mono.docs.v1.PingRequest");
_define_property(PingRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.docs.v1.PingResponse
 */ export class PingResponse extends Message {
    static fromBinary(bytes, options) {
        return new PingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingResponse, "runtime", proto3);
_define_property(PingResponse, "typeName", "mono.docs.v1.PingResponse");
_define_property(PingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.Document
 */ export class Document extends Message {
    static fromBinary(bytes, options) {
        return new Document().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Document().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Document().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Document, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * empty string means root
   *
   * @generated from field: string folder_id = 4;
   */ _define_property(this, "folderId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.docs.v1.DocumentType document_type = 6;
   */ _define_property(this, "documentType", 0), /**
   * @generated from field: int64 size_bytes = 7;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: int32 version_count = 8;
   */ _define_property(this, "versionCount", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * Where the document's current bytes live. When the document was created
   * via the tesoro-mediated path these match the tesoro artifact's location;
   * legacy direct-MinIO docs leave them empty and consumers fall back to
   * the deterministic per-version scheme. Consumers reading the bytes
   * (zou's GetVolumeDocumentContent → baltigo ExtractDocumentText) should
   * prefer these fields over re-deriving the key client-side.
   *
   * @generated from field: string storage_bucket = 11;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 12;
   */ _define_property(this, "storageKey", ""), /**
   * True when the document was created from real bytes (uploaded or authored in
   * the editor), false when minted as an empty chat shell awaiting a fill. Lets
   * the frontend hide unfilled shells without hiding populated single-version
   * documents.
   *
   * @generated from field: bool created_with_content = 13;
   */ _define_property(this, "createdWithContent", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Document, "runtime", proto3);
_define_property(Document, "typeName", "mono.docs.v1.Document");
_define_property(Document, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "document_type",
            kind: "enum",
            T: proto3.getEnumType(DocumentType)
        },
        {
            no: 7,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_with_content",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.Folder
 */ export class Folder extends Message {
    static fromBinary(bytes, options) {
        return new Folder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Folder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Folder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Folder, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * empty string means root
   *
   * @generated from field: string parent_id = 4;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Folder, "runtime", proto3);
_define_property(Folder, "typeName", "mono.docs.v1.Folder");
_define_property(Folder, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.docs.v1.DocumentVersion
 */ export class DocumentVersion extends Message {
    static fromBinary(bytes, options) {
        return new DocumentVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: int32 version_number = 3;
   */ _define_property(this, "versionNumber", 0), /**
   * @generated from field: int64 size_bytes = 4;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: string created_by_user_id = 5;
   */ _define_property(this, "createdByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentVersion, "runtime", proto3);
_define_property(DocumentVersion, "typeName", "mono.docs.v1.DocumentVersion");
_define_property(DocumentVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "created_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ----- ListDocuments -----
 *
 * @generated from message mono.docs.v1.ListDocumentsRequest
 */ export class ListDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Folder to list. Empty string lists root documents.
   *
   * @generated from field: string folder_id = 1;
   */ _define_property(this, "folderId", ""), /**
   * @generated from field: int32 page = 2;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * Optional name search (case-insensitive substring match).
   *
   * @generated from field: string search = 4;
   */ _define_property(this, "search", ""), /**
   * List across every folder as a flat set, ignoring folder_id. Used by surfaces
   * that show all of a user's documents wherever they live (chat resume, the
   * Artifacts tab) rather than browsing one folder at a time.
   *
   * @generated from field: bool all_folders = 5;
   */ _define_property(this, "allFolders", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentsRequest, "runtime", proto3);
_define_property(ListDocumentsRequest, "typeName", "mono.docs.v1.ListDocumentsRequest");
_define_property(ListDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "all_folders",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ListDocumentsResponse
 */ export class ListDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.Document documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentsResponse, "runtime", proto3);
_define_property(ListDocumentsResponse, "typeName", "mono.docs.v1.ListDocumentsResponse");
_define_property(ListDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: Document,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ----- GetDocument -----
 *
 * @generated from message mono.docs.v1.GetDocumentRequest
 */ export class GetDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentRequest, "runtime", proto3);
_define_property(GetDocumentRequest, "typeName", "mono.docs.v1.GetDocumentRequest");
_define_property(GetDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentResponse
 */ export class GetDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentResponse, "runtime", proto3);
_define_property(GetDocumentResponse, "typeName", "mono.docs.v1.GetDocumentResponse");
_define_property(GetDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- CreateDocument -----
 *
 * @generated from message mono.docs.v1.CreateDocumentRequest
 */ export class CreateDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.docs.v1.DocumentType document_type = 2;
   */ _define_property(this, "documentType", 0), /**
   * Empty string = root folder.
   *
   * @generated from field: string folder_id = 3;
   */ _define_property(this, "folderId", ""), /**
   * Optional starting bytes. When empty, a blank template is created.
   *
   * @generated from field: bytes initial_bytes = 4;
   */ _define_property(this, "initialBytes", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDocumentRequest, "runtime", proto3);
_define_property(CreateDocumentRequest, "typeName", "mono.docs.v1.CreateDocumentRequest");
_define_property(CreateDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "enum",
            T: proto3.getEnumType(DocumentType)
        },
        {
            no: 3,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "initial_bytes",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.CreateDocumentResponse
 */ export class CreateDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDocumentResponse, "runtime", proto3);
_define_property(CreateDocumentResponse, "typeName", "mono.docs.v1.CreateDocumentResponse");
_define_property(CreateDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- RenameDocument -----
 *
 * @generated from message mono.docs.v1.RenameDocumentRequest
 */ export class RenameDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenameDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameDocumentRequest, "runtime", proto3);
_define_property(RenameDocumentRequest, "typeName", "mono.docs.v1.RenameDocumentRequest");
_define_property(RenameDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RenameDocumentResponse
 */ export class RenameDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenameDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameDocumentResponse, "runtime", proto3);
_define_property(RenameDocumentResponse, "typeName", "mono.docs.v1.RenameDocumentResponse");
_define_property(RenameDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- MoveDocument -----
 *
 * @generated from message mono.docs.v1.MoveDocumentRequest
 */ export class MoveDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new MoveDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Empty string = root folder.
   *
   * @generated from field: string folder_id = 2;
   */ _define_property(this, "folderId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveDocumentRequest, "runtime", proto3);
_define_property(MoveDocumentRequest, "typeName", "mono.docs.v1.MoveDocumentRequest");
_define_property(MoveDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.MoveDocumentResponse
 */ export class MoveDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new MoveDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveDocumentResponse, "runtime", proto3);
_define_property(MoveDocumentResponse, "typeName", "mono.docs.v1.MoveDocumentResponse");
_define_property(MoveDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- DeleteDocument -----
 *
 * @generated from message mono.docs.v1.DeleteDocumentRequest
 */ export class DeleteDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDocumentRequest, "runtime", proto3);
_define_property(DeleteDocumentRequest, "typeName", "mono.docs.v1.DeleteDocumentRequest");
_define_property(DeleteDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.DeleteDocumentResponse
 */ export class DeleteDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDocumentResponse, "runtime", proto3);
_define_property(DeleteDocumentResponse, "typeName", "mono.docs.v1.DeleteDocumentResponse");
_define_property(DeleteDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * ----- Folder ops -----
 *
 * @generated from message mono.docs.v1.ListFoldersRequest
 */ export class ListFoldersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListFoldersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFoldersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFoldersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFoldersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty string = list root folders.
   *
   * @generated from field: string parent_id = 1;
   */ _define_property(this, "parentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFoldersRequest, "runtime", proto3);
_define_property(ListFoldersRequest, "typeName", "mono.docs.v1.ListFoldersRequest");
_define_property(ListFoldersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ListFoldersResponse
 */ export class ListFoldersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListFoldersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFoldersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFoldersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFoldersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.Folder folders = 1;
   */ _define_property(this, "folders", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFoldersResponse, "runtime", proto3);
_define_property(ListFoldersResponse, "typeName", "mono.docs.v1.ListFoldersResponse");
_define_property(ListFoldersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folders",
            kind: "message",
            T: Folder,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetFolderRequest
 */ export class GetFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFolderRequest, "runtime", proto3);
_define_property(GetFolderRequest, "typeName", "mono.docs.v1.GetFolderRequest");
_define_property(GetFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetFolderResponse
 */ export class GetFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Folder folder = 1;
   */ _define_property(this, "folder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFolderResponse, "runtime", proto3);
_define_property(GetFolderResponse, "typeName", "mono.docs.v1.GetFolderResponse");
_define_property(GetFolderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder",
            kind: "message",
            T: Folder
        }
    ]));
/**
 * @generated from message mono.docs.v1.CreateFolderRequest
 */ export class CreateFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * empty = root
   *
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateFolderRequest, "runtime", proto3);
_define_property(CreateFolderRequest, "typeName", "mono.docs.v1.CreateFolderRequest");
_define_property(CreateFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.CreateFolderResponse
 */ export class CreateFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateFolderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Folder folder = 1;
   */ _define_property(this, "folder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateFolderResponse, "runtime", proto3);
_define_property(CreateFolderResponse, "typeName", "mono.docs.v1.CreateFolderResponse");
_define_property(CreateFolderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder",
            kind: "message",
            T: Folder
        }
    ]));
/**
 * @generated from message mono.docs.v1.RenameFolderRequest
 */ export class RenameFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenameFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameFolderRequest, "runtime", proto3);
_define_property(RenameFolderRequest, "typeName", "mono.docs.v1.RenameFolderRequest");
_define_property(RenameFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RenameFolderResponse
 */ export class RenameFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenameFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameFolderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Folder folder = 1;
   */ _define_property(this, "folder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameFolderResponse, "runtime", proto3);
_define_property(RenameFolderResponse, "typeName", "mono.docs.v1.RenameFolderResponse");
_define_property(RenameFolderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder",
            kind: "message",
            T: Folder
        }
    ]));
/**
 * @generated from message mono.docs.v1.DeleteFolderRequest
 */ export class DeleteFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteFolderRequest, "runtime", proto3);
_define_property(DeleteFolderRequest, "typeName", "mono.docs.v1.DeleteFolderRequest");
_define_property(DeleteFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.DeleteFolderResponse
 */ export class DeleteFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteFolderResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteFolderResponse, "runtime", proto3);
_define_property(DeleteFolderResponse, "typeName", "mono.docs.v1.DeleteFolderResponse");
_define_property(DeleteFolderResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * ----- GetEditSession -----
 *
 * @generated from message mono.docs.v1.GetEditSessionRequest
 */ export class GetEditSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEditSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEditSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEditSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEditSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEditSessionRequest, "runtime", proto3);
_define_property(GetEditSessionRequest, "typeName", "mono.docs.v1.GetEditSessionRequest");
_define_property(GetEditSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetEditSessionResponse
 */ export class GetEditSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEditSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEditSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEditSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEditSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Full JSON string suitable as the `config` prop to
   * @onlyoffice/document-editor-react. Already signed with JWT.
   *
   * @generated from field: string editor_config_json = 1;
   */ _define_property(this, "editorConfigJson", ""), /**
   * Public URL of ONLYOFFICE Document Server (for DocumentEditor `documentServerUrl`).
   *
   * @generated from field: string document_server_url = 2;
   */ _define_property(this, "documentServerUrl", ""), /**
   * Document type short-form: "word", "cell", "slide".
   *
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEditSessionResponse, "runtime", proto3);
_define_property(GetEditSessionResponse, "typeName", "mono.docs.v1.GetEditSessionResponse");
_define_property(GetEditSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "editor_config_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_server_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- Versions -----
 *
 * @generated from message mono.docs.v1.ListVersionsRequest
 */ export class ListVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVersionsRequest, "runtime", proto3);
_define_property(ListVersionsRequest, "typeName", "mono.docs.v1.ListVersionsRequest");
_define_property(ListVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ListVersionsResponse
 */ export class ListVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.DocumentVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * The id of the version that is currently live. It is NOT necessarily the
   * highest version_number: a stale editor autosave that lost to a concurrent AI
   * apply is kept as a branch version with a higher number but is not current.
   * Clients must mark "current" by this id, not by max(version_number).
   *
   * @generated from field: string current_version_id = 2;
   */ _define_property(this, "currentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVersionsResponse, "runtime", proto3);
_define_property(ListVersionsResponse, "typeName", "mono.docs.v1.ListVersionsResponse");
_define_property(ListVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: DocumentVersion,
            repeated: true
        },
        {
            no: 2,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RestoreVersionRequest
 */ export class RestoreVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreVersionRequest, "runtime", proto3);
_define_property(RestoreVersionRequest, "typeName", "mono.docs.v1.RestoreVersionRequest");
_define_property(RestoreVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RestoreVersionResponse
 */ export class RestoreVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreVersionResponse, "runtime", proto3);
_define_property(RestoreVersionResponse, "typeName", "mono.docs.v1.RestoreVersionResponse");
_define_property(RestoreVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * DocumentOperation is one AI-proposed edit: an action name plus free-form,
 * action-specific params. Mirrors the shanks write-to-document tool output the
 * frontend forwards on approval. `params` is an untyped struct because each
 * action has its own shape (validated by the server-side translator).
 *
 * @generated from message mono.docs.v1.DocumentOperation
 */ export class DocumentOperation extends Message {
    static fromBinary(bytes, options) {
        return new DocumentOperation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentOperation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentOperation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentOperation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string action = 1;
   */ _define_property(this, "action", ""), /**
   * @generated from field: google.protobuf.Struct params = 2;
   */ _define_property(this, "params", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentOperation, "runtime", proto3);
_define_property(DocumentOperation, "typeName", "mono.docs.v1.DocumentOperation");
_define_property(DocumentOperation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "params",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.docs.v1.ApplyDocumentOperationsRequest
 */ export class ApplyDocumentOperationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyDocumentOperationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyDocumentOperationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyDocumentOperationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyDocumentOperationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: repeated mono.docs.v1.DocumentOperation operations = 2;
   */ _define_property(this, "operations", []), /**
   * Stable identity of one approved proposal. Repeating it must not produce
   * another document version, even after a lost response or service restart.
   *
   * @generated from field: string operation_id = 3;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyDocumentOperationsRequest, "runtime", proto3);
_define_property(ApplyDocumentOperationsRequest, "typeName", "mono.docs.v1.ApplyDocumentOperationsRequest");
_define_property(ApplyDocumentOperationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "operations",
            kind: "message",
            T: DocumentOperation,
            repeated: true
        },
        {
            no: 3,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ApplyDocumentOperationsResponse
 */ export class ApplyDocumentOperationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyDocumentOperationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyDocumentOperationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyDocumentOperationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyDocumentOperationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The updated document metadata (with a bumped version count).
   *
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * The new ONLYOFFICE document key. The client remounts the editor on this key
   * so the Document Server reloads the freshly-written bytes instead of serving
   * its stale cache.
   *
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyDocumentOperationsResponse, "runtime", proto3);
_define_property(ApplyDocumentOperationsResponse, "typeName", "mono.docs.v1.ApplyDocumentOperationsResponse");
_define_property(ApplyDocumentOperationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentTextRequest
 */ export class GetDocumentTextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentTextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * Windowed read for large documents: return the slice of the document's text
   * starting at this character (rune) offset. Defaults to 0 (the start).
   *
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * Maximum characters (runes) to return from offset. 0 applies the server
   * default window; the server also caps the maximum. Page by re-requesting with
   * offset advanced by the returned character_count.
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentTextRequest, "runtime", proto3);
_define_property(GetDocumentTextRequest, "typeName", "mono.docs.v1.GetDocumentTextRequest");
_define_property(GetDocumentTextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentTextResponse
 */ export class GetDocumentTextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentTextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The requested window of the document's text.
   *
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * Number of characters (runes) in this window.
   *
   * @generated from field: int32 character_count = 2;
   */ _define_property(this, "characterCount", 0), /**
   * Total characters (runes) in the whole document, so the caller knows how much
   * remains and whether to page further (offset + character_count < total_characters).
   *
   * @generated from field: int32 total_characters = 3;
   */ _define_property(this, "totalCharacters", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentTextResponse, "runtime", proto3);
_define_property(GetDocumentTextResponse, "typeName", "mono.docs.v1.GetDocumentTextResponse");
_define_property(GetDocumentTextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "character_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_characters",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
